const PREFIX = "ENTITYAPI_";
export const GET_ALL = `${PREFIX}GET_ALL`;
export const UPSERT = `${PREFIX}UPSERT`;